
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { ItineraryEvent } from '@/types/itinerary';
import EventCard from './EventCard';

interface DraggableEventProps {
  event: ItineraryEvent;
  index: number;
  isDragDisabled: boolean;
  onEdit?: (event: ItineraryEvent) => void;
  onDelete?: (eventId: string) => void;
}

const DraggableEvent: React.FC<DraggableEventProps> = ({
  event,
  index,
  isDragDisabled,
  onEdit,
  onDelete
}) => {
  return (
    <Draggable 
      key={event.id} 
      draggableId={event.id} 
      index={index}
      isDragDisabled={isDragDisabled}
    >
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${snapshot.isDragging ? 'opacity-70' : ''}`}
        >
          <EventCard 
            event={event} 
            onEdit={onEdit} 
            onDelete={onDelete}
          />
        </div>
      )}
    </Draggable>
  );
};

export default DraggableEvent;
